import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const sandboxRelayJiraPageRoute: InvariantJiraRoute = {
	name: 'sandbox-relay-defer-jira',
	path: '/jira/software/sandbox/relay/jirasearch',
	exact: true,
};
